import React, { useState } from "react";
import { AiOutlineFileText } from "react-icons/ai";

const Notes = () => {
  const [notes, setNotes] = useState([
    {
      id: 1,
      title: "Setup a meeting",
      date: "Apr 2, 2023",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut id dui mi.",
      isPrivate: true,
    },
    {
      id: 2,
      title: "Prepare presentation",
      date: "Apr 3, 2023",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut id dui mi.",
      isPrivate: true,
    },
    {
      id: 3,
      title: "Weekly report",
      date: "Apr 4, 2023",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut id dui mi.",
      isPrivate: false,
    },
  ]);

  const [selectedNote, setSelectedNote] = useState(null);

  const handleNoteClick = (note) => {
    setSelectedNote(note);
  };

  const handleAddNote = () => {
    const newNote = {
      id: notes.length + 1,
      title: "New Note",
      date: new Date().toLocaleDateString(),
      content: "This is a new note.",
      isPrivate: false,
    };
    setNotes([...notes, newNote]);
    setSelectedNote(newNote);
  };

  return (
    <div className="flex h-screen">
      {/* Notes List */}
      <div className="w-1/3 bg-gray-50 p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">All Notes</h2>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            onClick={handleAddNote}
          >
            + New Note
          </button>
        </div>
        <div className="grid grid-cols-1 gap-4">
          {notes.map((note) => (
            <div
              key={note.id}
              className="p-4 bg-white rounded-md shadow cursor-pointer hover:shadow-lg transition"
              onClick={() => handleNoteClick(note)}
            >
              <div className="flex items-center mb-2">
                <AiOutlineFileText className="text-blue-500 w-6 h-6 mr-3" />
                <div>
                  <h3 className="font-medium text-gray-800">{note.title}</h3>
                  <p className="text-sm text-gray-500">{note.date}</p>
                </div>
              </div>
              <p className="text-sm text-gray-600">{note.content}</p>
              {note.isPrivate && (
                <span className="text-sm text-purple-500 font-medium mt-2 inline-block">Private</span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Note Details */}
      <div className="w-2/3 p-6 bg-white shadow-lg">
        {selectedNote ? (
          <div>
            <h2 className="text-lg font-semibold mb-2">{selectedNote.title}</h2>
            <div className="flex items-center space-x-4 mb-4">
              <span className="text-gray-500 text-sm">Room Name: Case #987678904</span>
              <div className="flex space-x-2">
                <button
                  className={`px-4 py-1 rounded-md text-sm border ${
                    selectedNote.isPrivate
                      ? "bg-purple-100 text-purple-700"
                      : "bg-gray-100 text-gray-700"
                  }`}
                >
                  {selectedNote.isPrivate ? "Private" : "Public"}
                </button>
              </div>
            </div>
            <textarea
              className="w-full h-64 p-4 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedNote.content}
              onChange={(e) =>
                setSelectedNote({ ...selectedNote, content: e.target.value })
              }
            />
          </div>
        ) : (
          <p className="text-gray-500">Select a note to view details</p>
        )}
      </div>
    </div>
  );
};

export default Notes;
